import { homedir } from 'os';
import { join } from 'path';

/**
 * Resolve the CloudGrid config directory, respecting the CLOUDGRID_HOME
 * env var for test isolation and containerized dev flows.
 *
 * Why a helper (not a cached module-level constant): `vi.mock('node:os', ...)`
 * in CLI tests would race the module-load-time `homedir()` call and silently
 * miss, writing test fixtures over the real user's ~/.cloudgrid/ directory.
 * The env-var approach is also the industry pattern (KUBECONFIG, XDG_CONFIG_HOME).
 *
 * Resolution order:
 *   1. `process.env.CLOUDGRID_HOME` if set and non-empty → use verbatim
 *   2. `join(homedir(), '.cloudgrid')` otherwise
 *
 * The function is not cached — each call re-resolves. Tests can set the env
 * var in `beforeEach` and unset it in `afterEach` without any re-import ceremony.
 */
export function getCloudGridHome(): string {
  const override = process.env.CLOUDGRID_HOME;
  if (override && override.length > 0) return override;
  return join(homedir(), '.cloudgrid');
}
